<template>
    <card-list-item @click="$emit('click')" :class="{'active': active}">
        <template v-slot:icon><i class="fa-fw fa-person-chalkboard" :class="{'fas': active, 'far': !active}"></i></template>
        <template v-slot:content>
            <div class="tile-title">{{provider.title}}</div>
        </template>
        <template v-slot:status>
            <div class="stats">

            </div>
        </template>
        <template v-slot:details>
<!--            <div class="tile-details">-->
<!--                <div class="data mt-1">-->
<!--                    <data-row mini title="ID">{{provider.id}}</data-row>-->
<!--                </div>-->
<!--            </div>-->
        </template>
    </card-list-item>
</template>

<script>
    import { mapActions, mapGetters } from "vuex";
    import Toolbar from "@/TIER/components/Toolbar";
    import DataRow from "@/TIER/components/DataRow";
    import CardListItem from "@/TIER/components/CardListItem";

    export default {
        name: 'ContentProviderTile',
        components: {CardListItem, DataRow, Toolbar},
        props: {
            provider: {
                type: Object,
                required: true
            },
            active: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                details: false
            }
        }
    }
</script>

<style lang="scss" scoped>
    .tile-title {
        font-size: 0.9rem;
        font-weight: bold;
    }

    .tile-details {
        margin-top: 0.5rem;
    }
</style>
